<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="tipo_instituicao.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Descrição:">
      <b-form-textarea
        v-model="tipo_instituicao.descricao"
        placeholder="Descrição"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    tipo_instituicao: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("tipos_instituicoes", ["tipo_instituicao"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.tipo_instituicao[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.tipo_instituicao.$touch();
      return !this.$v.tipo_instituicao.$anyError;
    },
  },
  created() {},
};
</script>
